export function navicon() {
    const naviconElement = document.querySelector('.site-navigation__navicon');
    if (!naviconElement._listenerInitialized) {
        naviconElement._listenerInitialized = true;
        naviconElement.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation(); // Prevent the event from bubbling up and closing the navigation immediately
            e.currentTarget.classList.toggle('site-navigation__navicon--active');
            document.querySelector('.site-navigation').classList.toggle('site-navigation--active');
            document.querySelector('.site-header').classList.toggle('site-header--active');
            document.body.classList.toggle('site-navigation--open');
        });
        
        // Add event listener to close navigation when clicking outside of it
        document.body.addEventListener('click', (e) => {
            if (!e.target.closest('.site-navigation')) {
                // If the clicked element is not within the navigation, close it
                naviconElement.classList.remove('site-navigation__navicon--active');
                document.querySelector('.site-navigation').classList.remove('site-navigation--active');
                document.querySelector('.site-header').classList.remove('site-header--active');
                document.body.classList.remove('site-navigation--open');
            }
        });
    }
}